import {axios} from "@/api/config";
// 查询风险分析对象管理列表
export function listRiskObject(params) {
  return axios.get(`/riskObject/list`, params, true);
}

// 查询风险分析对象管理详细
export function getRiskObject(riskObjectId) {
  return axios.get(`/riskObject/${riskObjectId}`, riskObjectId, true)
}

// 新增风险分析对象管理
export function addRiskObject(params) {
  return axios.post('/riskObject/addRiskObject', params, false);
}

// 修改风险分析对象管理
export function updateRiskObject(params) {
  return axios.post('/riskObject/editRiskObject', params, false);
}


// 删除风险分析对象管理
export function delRiskObject(riskObjectId) {
  return axios.delete(`/riskObject/${riskObjectId}`, true)
}

